import { useState } from "react";

interface StillGalleryProps {
  stills: string[];
  title: string;
}

export default function StillGallery({ stills, title }: StillGalleryProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const close = () => setActiveIndex(null);
  const prev = () =>
    setActiveIndex((current) =>
      current === null ? null : (current - 1 + stills.length) % stills.length,
    );
  const next = () =>
    setActiveIndex((current) => (current === null ? null : (current + 1) % stills.length));

  if (stills.length === 0) return null;

  return (
    <>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
        {stills.map((src, index) => (
          <button
            key={src}
            type="button"
            onClick={() => setActiveIndex(index)}
            className="relative shrink-0 w-[280px] sm:w-[360px] md:w-[440px] aspect-video rounded-lg overflow-hidden border border-background-200 cursor-pointer group"
          >
            <img
              src={src}
              alt={`${title} 剧照 ${index + 1}`}
              title={`${title} - 叶山小百合作品剧照`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute inset-0 bg-primary-950/0 group-hover:bg-primary-950/25 transition-colors flex items-center justify-center">
              <span className="w-10 h-10 rounded-full bg-background-50/90 text-primary-600 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-zoom-in-line text-xl"></i>
              </span>
            </span>
          </button>
        ))}
      </div>

      {activeIndex !== null && (
        <div
          className="fixed inset-0 z-[70] bg-primary-950/92 flex items-center justify-center p-4 animate-fade-in"
          onClick={close}
          role="presentation"
        >
          <button
            type="button"
            onClick={close}
            aria-label="关闭"
            className="absolute top-5 right-5 w-10 h-10 rounded-full border border-background-50/40 text-background-50 flex items-center justify-center hover:bg-background-50/15 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              prev();
            }}
            aria-label="上一张"
            className="absolute left-4 md:left-8 w-11 h-11 rounded-full border border-background-50/40 text-background-50 flex items-center justify-center hover:bg-background-50/15 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <img
            src={stills[activeIndex]}
            alt={`${title} 剧照放大预览`}
            title={`${title} - 剧照预览`}
            className="max-w-full max-h-[85vh] rounded-lg object-contain"
            onClick={(event) => event.stopPropagation()}
          />

          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              next();
            }}
            aria-label="下一张"
            className="absolute right-4 md:right-8 w-11 h-11 rounded-full border border-background-50/40 text-background-50 flex items-center justify-center hover:bg-background-50/15 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <span className="absolute bottom-6 left-1/2 -translate-x-1/2 text-sm text-background-50/70">
            {activeIndex + 1} / {stills.length}
          </span>
        </div>
      )}
    </>
  );
}